import React, { useEffect } from "react";
import { Redirect, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import querystring from "querystring";
import { fetchUser } from "../actions/user";
import { verifyAccount } from "../actions/auth";
import Spinner from "./presentational/Spinner";
const VerifyEmail = () => {
    const { success, error } = useSelector((state) => state.auth.requests.verifyAccount);
    const { token: loggedIn } = useSelector((state) => state.auth.data);
    const loc = useLocation();
    const dispatch = useDispatch();
    const finished = success || error;
    useEffect(() => {
        if (finished && loggedIn) {
            dispatch(fetchUser.request());
        }
    }, [dispatch, finished, loggedIn]);
    useEffect(() => {
        const token = querystring.parse(loc.search.substring(1)).token;
        if (token) {
            dispatch(verifyAccount.request({ token }));
        }
    }, [dispatch, loc.search]);
    const getAlertMessage = () => {
        if (error) {
            return error;
        }
        if (typeof success === "string") {
            return success;
        }
        return "Success!";
    };
    if (finished) {
        return (React.createElement(Redirect, { to: {
                pathname: loggedIn ? "/dashboard" : "/login",
                state: {
                    alert: {
                        kind: error ? "error" : "success",
                        message: getAlertMessage()
                    }
                }
            } }));
    }
    return (React.createElement("section", { className: "popup-form" },
        React.createElement("div", { style: {
                fontSize: "800%",
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translateX(-50%) translateY(-50%)"
            } },
            React.createElement(Spinner, null))));
};
export default VerifyEmail;
